export default __webpack_public_path__ + "images/10da839c835180df5441d0c5e66a7836.svg";